import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, renderList as _renderList, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Thông tin chi tiết hồ sơ ứng viên", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_13 = { class: "flex-column flex-lg-row-auto w-100 w-xl-300px mb-10" }
const _hoisted_14 = { class: "card mb-5 mb-xl-8" }
const _hoisted_15 = { class: "card-body py-5" }
const _hoisted_16 = { class: "d-flex flex-center flex-column" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-100px symbol-circle mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/avatars/blank.png",
    alt: "image"
  })
], -1)
const _hoisted_18 = { class: "d-flex flex-center flex-wrap gap-4 mb-1" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "svg-icon svg-icon-primary" }
const _hoisted_21 = { class: "ms-1" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "svg-icon svg-icon-primary" }
const _hoisted_24 = { class: "ms-1" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex flex-wrap flex-center gap-5 py-3 wrapper-rounded-hover"
}
const _hoisted_26 = { class: "fs-4 fw-bolder text-gray-700 text-center" }
const _hoisted_27 = { class: "svg-icon svg-icon-2x" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, "In hồ sơ", -1)
const _hoisted_29 = { class: "fs-4 fw-bolder text-gray-700 text-center" }
const _hoisted_30 = { class: "svg-icon svg-icon-2x" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, "Gửi email", -1)
const _hoisted_32 = { class: "fs-4 fw-bolder text-gray-700 text-center" }
const _hoisted_33 = { class: "svg-icon svg-icon-2x" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, "Tải hồ sơ", -1)
const _hoisted_35 = {
  key: 0,
  class: "card card-flush py-4 mb-5 mb-xl-8 umt-form"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Trạng thái hồ sơ")
  ])
], -1)
const _hoisted_37 = { class: "card-body pt-0 fs-6" }
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal" }, "Kết quả xét tuyển", -1)
const _hoisted_40 = {
  key: 0,
  class: "fw-bolder text-success"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill me-1 text-success" }, null, -1)
const _hoisted_42 = {
  key: 1,
  class: "fw-bolder text-danger"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill me-1 text-danger" }, null, -1)
const _hoisted_44 = {
  key: 2,
  class: "fw-bolder text-gray-600"
}
const _hoisted_45 = { class: "text-muted fs-8 fst-italic mt-1 text-end" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_52 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal" }, "Xác thực hồ sơ", -1)
const _hoisted_54 = { class: "d-flex align-items-center gap-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-7" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Lý do", -1)
const _hoisted_59 = { class: "text-end mt-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_61 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal" }, "Tốt nghiệp THPT", -1)
const _hoisted_63 = { class: "d-flex align-items-center gap-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-7" }, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-7" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "text-end mt-2" }
const _hoisted_69 = {
  key: 1,
  class: "card card-flush py-4 mb-5 mb-xl-8"
}
const _hoisted_70 = {
  key: 4,
  class: "text-center mb-5 mb-xl-8"
}
const _hoisted_71 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_72 = { class: "card flex-lg-row-fluid ms-lg-8 profile-detail" }
const _hoisted_73 = { class: "card card-flush py-4 mb-5" }
const _hoisted_74 = { class: "card-header" }
const _hoisted_75 = { class: "d-flex align-items-center justify-content-between w-100 mt-3 mb-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary text-uppercase fs-5 ps-3 border-start border-4 border-primary" }, "Thông tin xét tuyển", -1)
const _hoisted_77 = ["title"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-700 fs-7 text-nowrap" }, "Kích hoạt hồ sơ", -1)
const _hoisted_79 = ["checked", "disabled"]
const _hoisted_80 = {
  key: 0,
  class: "mt-3 w-100 umt-form"
}
const _hoisted_81 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_82 = { class: "fv-row w-100" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold required" }, "Nguồn", -1)
const _hoisted_84 = { class: "fv-row w-100" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold required" }, "Ngày tạo", -1)
const _hoisted_86 = { class: "fv-row w-100" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold required" }, "Đợt", -1)
const _hoisted_88 = {
  key: 0,
  class: "mb-3 fv-row w-100 text-center"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-semibold mb-5 cursor-pointer",
  for: "checkbox4"
}, "Là đợt bổ sung", -1)
const _hoisted_90 = ["disabled"]
const _hoisted_91 = {
  key: 1,
  class: "text-end"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white d-block" }, ".", -1)
const _hoisted_93 = {
  key: 0,
  class: "d-flex justify-content-end flex-nowrap gap-2"
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary btn-sm",
  type: "submit"
}, "Lưu", -1)
const _hoisted_95 = {
  key: 1,
  class: "btn btn-primary btn-sm min-w-100px",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ProfileDetailInfor = _resolveComponent("ProfileDetailInfor")!
  const _component_WidgetComment = _resolveComponent("WidgetComment")!
  const _component_WidgetAssign = _resolveComponent("WidgetAssign")!
  const _component_WidgetAssignHistory = _resolveComponent("WidgetAssignHistory")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddCustomerModal = _resolveComponent("AddCustomerModal")!
  const _component_ModalDeleteAndReason = _resolveComponent("ModalDeleteAndReason")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW,_ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            (_ctx.dataAdmissionRegister?.adRegister?.idAdMethod == 9)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/danhsachdangkylienthong",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Danh sách ứng viên liên thông")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/danhsachhoso",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Danh sách hồ sơ")
                  ]),
                  _: 1
                }))
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${_ctx.dataCustomer.id}`,
                  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dataCustomer.fullName), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("a", {
                    class: "d-flex align-items-center fs-7",
                    href: `tel:${_ctx.dataCustomer.phone}`
                  }, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/phone.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.dataCustomer.phone), 1)
                  ], 8, _hoisted_19),
                  _createElementVNode("a", {
                    class: "d-flex align-items-center fs-7",
                    href: `mailto:${_ctx.dataCustomer.email}`
                  }, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/mail.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.dataCustomer.email), 1)
                  ], 8, _hoisted_22)
                ]),
                (!_ctx.dataCustomer.isArchived)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_ctx.dataAdmissionRegister?.adRegister?.idAdMethod != 9)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "border border-gray-300 border-dashed rounded py-3 px-3 cursor-pointer",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPdf(_ctx.profileCode)))
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/printer.svg" })
                              ])
                            ]),
                            _hoisted_28
                          ])), [
                            [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_PRINT,_ctx.Permission.ADMISSION_REGISTER]]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.dataAdmissionRegister?.adRegister?.idAdMethod != 9)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "border border-gray-300 border-dashed rounded py-3 px-3 cursor-pointer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.yesNoEmail(_ctx.idAdReg)))
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/mail.svg" })
                              ])
                            ]),
                            _hoisted_31
                          ])), [
                            [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EMAIL,_ctx.Permission.ADMISSION_REGISTER]]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "border border-gray-300 border-dashed rounded py-3 px-3 cursor-pointer",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadAdmission(_ctx.idAdReg)))
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil017.svg" })
                          ])
                        ]),
                        _hoisted_34
                      ])), [
                        [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_DOWNLOAD,_ctx.Permission.ADMISSION_REGISTER]]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.dataAdmissionRegister?.adRegister)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["rounded p-3 mb-1", _ctx.dataAdmissionRegister.adRegister.isPassed === true ? 'bg-light-success border border-success border-dashed'
                      : (_ctx.dataAdmissionRegister.adRegister.isPassed === false ? 'bg-light-danger border border-danger border-dashed'
                      : 'bg-light border border-gray-300 border-dashed')])
                  }, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      (_ctx.dataAdmissionRegister.adRegister.isPassed === true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            _hoisted_41,
                            _createTextVNode("Trúng tuyển ")
                          ]))
                        : (_ctx.dataAdmissionRegister.adRegister.isPassed === false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                              _hoisted_43,
                              _createTextVNode("Không trúng ")
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_44, "Chưa xét"))
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      (_ctx.dataAdmissionRegister.adRegister.isPassed === true)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.dataAdmissionRegister.adRegister._adwinner?.decisionCode)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                  _createTextVNode(" QĐ " + _toDisplayString(_ctx.dataAdmissionRegister.adRegister._adwinner.decisionCode), 1),
                                  (_ctx.dataAdmissionRegister.adRegister._adwinner.decisionDate)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, " · " + _toDisplayString(_ctx.formatDate(_ctx.dataAdmissionRegister.adRegister._adwinner.decisionDate)), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_48, "Chưa gán số quyết định"))
                          ], 64))
                        : (_ctx.dataAdmissionRegister.adRegister.isPassed === false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Hồ sơ đã lưu trữ"))
                          : (_ctx.dataAdmissionRegister.adRegister.isAppraised)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Đã thẩm định, chờ chốt xét tuyển"))
                            : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _hoisted_51,
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        (!_ctx.isChangeStatus)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(`badge badge-light-${_ctx.statusTag[_ctx.statusRecord]?.state || 'primary'}`)
                            }, _toDisplayString(_ctx.statusTag[_ctx.statusRecord]?.label || _ctx.statusRecord), 3))
                          : _createCommentVNode("", true),
                        (!_ctx.isChangeStatus && !_ctx.isAppraised)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "btn btn-icon btn-sm btn-active-light-primary",
                              title: "Đổi trạng thái xác thực",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.editStatus && _ctx.editStatus(...args)))
                            }, _hoisted_56))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.isChangeStatus)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid w-100 mt-2",
                            modelValue: _ctx.statusRecord,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.statusRecord) = $event)),
                            disabled: _ctx.isAppraised,
                            filterable: true,
                            placeholder: "Chọn trạng thái"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Mới",
                                value: "new"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Đã xác thực",
                                value: "verified"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Chưa hoàn tất",
                                value: "processing"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Đang xem xét",
                                value: "reviewing"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Không hợp lệ",
                                value: "rejected"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Từ chối",
                                value: "denied"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"]),
                          (_ctx.statusRecord == 'rejected')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _hoisted_58,
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rejectReason) = $event)),
                                  class: "form-control form-control-solid",
                                  style: {"height":"60px"}
                                }, null, 512), [
                                  [_vModelText, _ctx.rejectReason]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("span", {
                              class: "btn btn-light btn-sm me-2",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelStatus && _ctx.cancelStatus(...args)))
                            }, "Hủy"),
                            _createElementVNode("span", {
                              class: "btn btn-primary btn-sm min-w-80px",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveStatus && _ctx.saveStatus(...args)))
                            }, "Lưu")
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS,_ctx.Permission.ADMISSION_REGISTER]]
                  ]),
                  _hoisted_60,
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.isHighschool ? 'bg-light-danger rounded p-2' : '')
                  }, [
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        (!_ctx.isChangeStatusGraduated)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(`badge badge-light-${_ctx.graduationTag[_ctx.dataCustomer.highschoolGraduation]?.state || 'secondary'}`)
                            }, _toDisplayString(_ctx.graduationTag[_ctx.dataCustomer.highschoolGraduation]?.label || 'Chưa xác định'), 3))
                          : _createCommentVNode("", true),
                        (!_ctx.isChangeStatusGraduated)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_ctx.dataAdmissionRegister.adRegister.isAppraised)
                                ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "btn btn-icon btn-sm btn-active-light-primary",
                                    title: "Đổi điều kiện tốt nghiệp",
                                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeStatusGraduated && _ctx.changeStatusGraduated(...args)))
                                  }, _hoisted_65)), [
                                    [_directive_permission, [_ctx.Permission.STUDENT_EDIT_GRADUATION,_ctx.Permission.STUDENT]]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "btn btn-icon btn-sm btn-active-light-primary",
                                    title: "Đổi điều kiện tốt nghiệp",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeStatusGraduated && _ctx.changeStatusGraduated(...args)))
                                  }, _hoisted_67)), [
                                    [_directive_permission, [_ctx.Permission.ADMISSION_EDIT_GRADUATION,_ctx.Permission.ADMISSION]]
                                  ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.isChangeStatusGraduated)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid w-100 mt-2",
                            placeholder: "Chọn điều kiện tốt nghiệp THPT",
                            modelValue: _ctx.dataCustomer.highschoolGraduation,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataCustomer.highschoolGraduation) = $event)),
                            ref: "statusGraduated",
                            filterable: true
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Chưa tốt nghiệp THPT",
                                value: "not_graduated"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Giấy chứng nhận TNTT",
                                value: "temp_graduated"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Đã tốt nghiệp THPT",
                                value: "graduated"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("span", {
                              class: "btn btn-light btn-sm me-2",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.cancelGraduated && _ctx.cancelGraduated(...args)))
                            }, "Hủy"),
                            _createElementVNode("span", {
                              class: "btn btn-primary btn-sm min-w-80px",
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changeStatusGraduated && _ctx.changeStatusGraduated(...args)))
                            }, "Lưu")
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataCustomer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createVNode(_component_ProfileDetailInfor, { "data-customer": _ctx.dataCustomer }, null, 8, ["data-customer"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataCustomer.id)
            ? (_openBlock(), _createBlock(_component_WidgetComment, {
                key: 2,
                class: "mb-5 mb-xl-8",
                idStudent: _ctx.dataCustomer.id
              }, null, 8, ["idStudent"]))
            : _createCommentVNode("", true),
          _createVNode(_component_WidgetAssign, {
            dataCustomer: _ctx.dataCustomer,
            class: "mb-5 mb-xl-8"
          }, null, 8, ["dataCustomer"]),
          (_ctx.dataCustomer.id)
            ? (_openBlock(), _createBlock(_component_WidgetAssignHistory, {
                key: 3,
                idStudent: _ctx.dataCustomer.id,
                class: "mb-5 mb-xl-8"
              }, null, 8, ["idStudent"]))
            : _createCommentVNode("", true),
          (_ctx.dataAdmissionRegister?.adRegister && _ctx.dataAdmissionRegister.adRegister.status != 'verified' && !_ctx.dataAdmissionRegister.adRegister.isPassed)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light-danger w-100",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.callModalDelete && _ctx.callModalDelete(...args)))
                }, [
                  _createElementVNode("span", _hoisted_71, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                  ]),
                  _createTextVNode(" Xóa hồ sơ ")
                ])
              ])), [
                [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_DELETE, _ctx.Permission.ADMISSION_REGISTER]]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                (_ctx.dataAdmissionRegister?.adRegister)
                  ? _withDirectives((_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: "d-flex align-items-center gap-2 form-check form-switch form-check-custom form-check-solid",
                      title: _ctx.isAppraised ? 'Hồ sơ đã thẩm định — khóa' : (_ctx.dataAdmissionRegister.adRegister.isActive ? 'Đang kích hoạt — bấm để tắt' : 'Đang tắt kích hoạt — bấm để bật')
                    }, [
                      _hoisted_78,
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        checked: _ctx.dataAdmissionRegister.adRegister.isActive,
                        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.toggleActiveConfirm()), ["prevent"])),
                        disabled: _ctx.isAppraised
                      }, null, 8, _hoisted_79)
                    ], 8, _hoisted_77)), [
                      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS,_ctx.Permission.ADMISSION_REGISTER]]
                    ])
                  : _createCommentVNode("", true)
              ]),
              (_ctx.dataAdmissionRegister)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createVNode(_component_el_form, {
                      onSubmit: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.changeSource()), ["prevent"])),
                      model: _ctx.dataFormRegister,
                      rules: _ctx.rules,
                      ref: "formRef"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _hoisted_83,
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              placeholder: "Nguồn",
                              disabled: !_ctx.isChangeSource,
                              modelValue: _ctx.dataFormRegister.source,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dataFormRegister.source) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrResource, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _createVNode(_component_el_form_item, { prop: "createdAt" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  class: "w-100",
                                  modelValue: _ctx.dataFormRegister.createdAt,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dataFormRegister.createdAt) = $event)),
                                  name: "createdAt",
                                  disabled: !_ctx.isChangeSource,
                                  placeholder: "Ngày/tháng/năm",
                                  format: "DD/MM/YYYY"
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _hoisted_87,
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              placeholder: "Đợt xét tuyển",
                              disabled: !_ctx.isChangeSource,
                              modelValue: _ctx.dataFormRegister.phase,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dataFormRegister.phase) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhase, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          (_ctx.dataFormRegister.source !='online')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _hoisted_89,
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  value: true,
                                  disabled: !_ctx.isChangeSource,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.additionalPhase) = $event)),
                                  id: "checkbox4"
                                }, null, 8, _hoisted_90), [
                                  [_vModelCheckbox, _ctx.additionalPhase]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isAppraised)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_91, [
                                _hoisted_92,
                                (_ctx.isChangeSource)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-light btn-sm",
                                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.cancelSource && _ctx.cancelSource(...args)))
                                      }, "Hủy"),
                                      _hoisted_94
                                    ]))
                                  : (_openBlock(), _createElementBlock("button", _hoisted_95, "Thay đổi"))
                              ])), [
                                [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS,_ctx.Permission.ADMISSION_REGISTER]]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.dataAdmissionRegister)
            ? (_openBlock(), _createBlock(_component_AddCustomerModal, {
                key: 0,
                ref: "callAddCustomerModal",
                "from-profile": true,
                "is-edit": _ctx.isEdit,
                "is-appraised": _ctx.isAppraised,
                priorityScore: _ctx.prScore,
                idStudent: _ctx.idStudent,
                "data-adm": _ctx.dataAdmissionRegister,
                "data-highschool": _ctx.submithighschoolGraduation,
                onCallbackFunction: _ctx.checkHighschoolGraduation,
                "order-number": _ctx.dataCustomer.orderNumber
              }, null, 8, ["is-edit", "is-appraised", "priorityScore", "idStudent", "data-adm", "data-highschool", "onCallbackFunction", "order-number"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ModalDeleteAndReason, {
      ref: "callFunctionModal",
      id: "auth_delete_profile",
      title: "Xác nhận xóa hồ sơ này",
      "warning-text": "Hồ sơ đăng ký xét tuyển sẽ được ĐÁNH DẤU ĐÃ XÓA (xóa mềm — khôi phục được ở danh sách hồ sơ đã xóa). Không xóa ứng viên và KHÔNG gỡ dữ liệu đã đẩy lên Salesforce.",
      onCallBackDelete: _ctx.isDeleteFunction
    }, null, 8, ["onCallBackDelete"])
  ], 64))
}